import { changePageIfAppropriate, numberOfPagesFromItems, getPagesRange } from './helpers.es.js';

const usePagination = ({
  currentPage,
  isTruncated,
  items,
  itemsPerPage,
  pagesPerSlice,
  onPageChanged
}) => {
  const goToPage = (pageNumber) => changePageIfAppropriate(pageNumber, items, itemsPerPage, onPageChanged);
  const numberOfPages = numberOfPagesFromItems(items, itemsPerPage);
  const shouldTruncate = isTruncated && numberOfPages > pagesPerSlice;
  const truncationOffset = shouldTruncate ? 2 : 0;
  const _pagesPerSlice = shouldTruncate ? pagesPerSlice - truncationOffset : pagesPerSlice;
  let rangeFirstPage;
  let rangeLastPage;
  let hasEndRange = false;
  if (numberOfPages <= _pagesPerSlice) {
    rangeFirstPage = 1;
    rangeLastPage = numberOfPages;
  } else {
    const pagesBeforeCurrentPage = Math.floor(_pagesPerSlice / 2);
    const pagesAfterCurrentPage = Math.ceil(_pagesPerSlice / 2) - 1;
    if (currentPage <= pagesBeforeCurrentPage) {
      rangeFirstPage = 1;
      rangeLastPage = _pagesPerSlice;
      hasEndRange = false;
    } else if (currentPage + pagesAfterCurrentPage + truncationOffset >= numberOfPages) {
      rangeFirstPage = numberOfPages - _pagesPerSlice + 1;
      rangeLastPage = numberOfPages;
      hasEndRange = true;
    } else {
      rangeFirstPage = currentPage - pagesBeforeCurrentPage;
      rangeLastPage = currentPage + pagesAfterCurrentPage;
    }
  }
  const pagesRange = getPagesRange(rangeFirstPage, rangeLastPage);
  const startRange = hasEndRange ? [1] : pagesRange;
  const endRange = hasEndRange ? pagesRange : [numberOfPages];
  return { numberOfPages, pagesRange, shouldTruncate, startRange, endRange, goToPage };
};

export { usePagination as default };
//# sourceMappingURL=usePagination.es.js.map
